import * as React from "react";

import { Typography } from "@components/atoms";
import Image from "./Image";

import { Container, Content } from "./NotFound.styles";

const NotFound: React.FunctionComponent = () => {
  return (
    <Container>
      <Content>
        <Image />
        <Typography variant="h3">Page Not Found</Typography>
        <Typography variant="body" align="center">
          This page was either abducted by aliens, or it no longer exists.
        </Typography>
      </Content>
    </Container>
  );
};

export default NotFound;
